import type { ReactNode } from 'react';

interface Props {
  caption?: string;
  children: ReactNode;
}

export function Diagram({ caption, children }: Props) {
  return (
    <figure className="my-5">
      <div className="flex justify-center rounded-lg border border-purple-200 bg-gradient-to-b from-purple-100 to-guide-surface p-5">
        {children}
      </div>
      {caption && (
        <figcaption className="mt-2 text-center text-xs italic text-guide-text-muted">{caption}</figcaption>
      )}
    </figure>
  );
}
